import React, { useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X } from 'lucide-react';
interface LegalModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  content: React.ReactNode;
}
export function LegalModal({
  isOpen,
  onClose,
  title,
  content
}: LegalModalProps) {
  // Prevent body scroll when modal is open
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isOpen]);
  // Close on escape key
  useEffect(() => {
    const handleEsc = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    window.addEventListener('keydown', handleEsc);
    return () => window.removeEventListener('keydown', handleEsc);
  }, [onClose]);
  return <AnimatePresence data-id="element-85">
      {isOpen && <>
          {/* Backdrop */}
          <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} onClick={onClose} className="fixed inset-0 bg-black/60 backdrop-blur-sm z-50" aria-hidden="true" data-id="element-86" />

          {/* Modal Container */}
          <div className="fixed inset-0 z-50 flex items-center justify-center p-4 sm:p-6 pointer-events-none" data-id="element-87">
            <motion.div initial={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} animate={{
          opacity: 1,
          scale: 1,
          y: 0
        }} exit={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} transition={{
          duration: 0.2
        }} className="bg-[#15202B] border border-[#B8A99A]/10 w-full max-w-2xl max-h-[80vh] rounded-xl shadow-2xl flex flex-col pointer-events-auto" role="dialog" aria-modal="true" aria-labelledby="modal-title" data-id="element-88">
              {/* Header */}
              <div className="flex items-center justify-between p-6 border-b border-[#B8A99A]/10" data-id="element-89">
                <h2 id="modal-title" className="text-xl font-bold text-[#F5E6D0] font-sans" data-id="element-90">
                  {title}
                </h2>
                <button onClick={onClose} className="text-[#B8A99A] hover:text-[#E8614D] transition-colors p-1 rounded-md hover:bg-[#B8A99A]/5 focus:outline-none focus:ring-2 focus:ring-[#E8614D]/50" aria-label="Cerrar" data-id="element-91">
                  <X className="w-6 h-6" data-id="element-92" />
                </button>
              </div>

              {/* Content */}
              <div className="p-6 overflow-y-auto custom-scrollbar text-[#B8A99A] font-serif leading-relaxed space-y-4" data-id="element-93">
                {content}
              </div>
            </motion.div>
          </div>
        </>}
    </AnimatePresence>;
}